
import jsPDF from "jspdf";
import WbdIcon from '../../../Images/logo-wirebit-pdf.png';
import '../../../fonts/DMSans-Regular.js'
import '../../../fonts/DMSans-Medium.js'
import FormatMoney from "../../../Helpers/formatMoney";

const ConvertDate = (date) =>{
  let monthNames=  ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio","Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  let _date=new Date(String(date).replace(/-/g, '\/'))
  return(`${_date.getDate()} de ${monthNames[_date.getMonth()]} del ${_date.getFullYear()}`);
}

export const TemplatePdf = async(data) => {
  const {
    service,
    service_full_name,
    currency_amount,
    currency_coin,
    date,
    number,
    authorization
  } = data;

  const doc = new jsPDF();

  const imageWidth = 40; // Ancho de la imagen (en unidades del documento)
  const imageHeight = 9; // Alto de la imagen (en unidades del documento)

  const pageWidth = doc.internal.pageSize.getWidth(); // Ancho de la página del documento
  const pageHeight = doc.internal.pageSize.getHeight();
  const x = (pageWidth - imageWidth) / 2; // Coordenada X para centrar horizontalmente

  doc.addImage(WbdIcon, "JPEG", x, 12, imageWidth, imageHeight);
  
  doc.setFont('DMSans-Medium', 'normal');
  doc.setFontSize(20); // Establecer el tamaño de fuente
  doc.setTextColor('#0F0F0F'); // Establecer el color de texto
  doc.text('¡Pago realizado con éxito!', 10, 40);

  const text_description = 'Tu pago de servicio se realizó con éxito, a continuación'
  const text_description_2 = 'te presentamos el resumen de tu transacción.'
  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(18); // Establecer el tamaño de fuente
  doc.setTextColor('#0F0F0F'); // Establecer el color de texto
  doc.text(text_description, 10, 50);
  doc.text(text_description_2, 10, 60);

  const startX = 10; // Coordenada X de inicio de la línea
  const startY = 65; // Coordenada Y de inicio de la línea
  const endX = 200; // Coordenada X de fin de la línea
  const endY = 65; // Coordenada Y de fin de la línea

  const lineColor = '#707070'; // Color de la línea en formato hexadecimal

  doc.setDrawColor(lineColor); // Establecer el color de trazo
  doc.line(startX, startY, endX, endY);

  // Fila Monto
  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#A0A0A0'); // Establecer el color de texto
  doc.text('Monto:', 10, 85)

  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#101010'); // Establecer el color de texto
  doc.setFont('DMSans-Medium', 'normal');
  const ammount = FormatMoney(currency_amount) + ' ' + currency_coin.toUpperCase()
  const getWidth = doc.internal.pageSize.getWidth(); // Ancho de la página del documento
  const getTextWidth = doc.getStringUnitWidth(ammount) * 16 / doc.internal.scaleFactor; // Ancho del texto en unidades del documento
  const vectorX = getWidth - getTextWidth - 12; // Coordenada X para alinear a la derecha
  doc.text(ammount, vectorX, 85)
  
  //Servicio 
  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#A0A0A0'); // Establecer el color de texto
  doc.text('Servicio:', 10, 105)

  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(13); // Establecer el tamaño de fuente
  doc.setTextColor('#101010'); // Establecer el color de texto

  const pagWidth = doc.internal.pageSize.getWidth(); // Ancho de la página del documento
  const textWidth = doc.getStringUnitWidth(service_full_name) * 13 / doc.internal.scaleFactor; // Ancho del texto en unidades del documento
  const ejex = pagWidth - textWidth - 10; // Coordenada X para alinear a la derecha
  const ejey = 105; // Coordenada Y para la posición vertical
  doc.text(service_full_name, ejex, ejey)

  //Fecha de pago 
  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#A0A0A0'); // Establecer el color de texto
  doc.text('Fecha de pago:', 10, 125)

  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#101010'); // Establecer el color de texto

  const getPagW = doc.internal.pageSize.getWidth(); // Ancho de la página del documento
  const getWidthText = doc.getStringUnitWidth(ConvertDate(date)) * 16 / doc.internal.scaleFactor; // Ancho del texto en unidades del documento
  const ejx = getPagW - getWidthText - 12; // Coordenada X para alinear a la derecha
  doc.text(ConvertDate(date), ejx, 125)

  // Numero de solicitud

  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#A0A0A0'); // Establecer el color de texto
  doc.text('Número de solicitud:', 10, 145)

  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#101010'); // Establecer el color de texto

  const getWidthPage = doc.internal.pageSize.getWidth(); // Ancho de la página del documento
  const getWidthNumber = doc.getStringUnitWidth(number) * 16 / doc.internal.scaleFactor; // Ancho del texto en unidades del documento
  const x_eje = getWidthPage - getWidthNumber - 12; // Coordenada X para alinear a la derecha
  doc.text(number, x_eje, 145)

  // Numero de referencia

  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#A0A0A0'); // Establecer el color de texto
  doc.text('Número de referencia:', 10, 165)

  doc.setFont('DMSans-Regular', 'normal');
  doc.setFontSize(16); // Establecer el tamaño de fuente
  doc.setTextColor('#101010'); // Establecer el color de texto

  const getWidthDoc = doc.internal.pageSize.getWidth(); // Ancho de la página del documento
  const getWidthReference = doc.getStringUnitWidth(authorization) * 16 / doc.internal.scaleFactor; // Ancho del texto en unidades del documento
  const eje_x = getWidthDoc - getWidthReference - 12; // Coordenada X para alinear a la derecha
  doc.text(authorization, eje_x, 165)

  // Footer
    doc.setFont('DMSans-Regular', 'normal');
    doc.setFontSize(14); // Establecer el tamaño de fuente
    doc.setTextColor('#000000'); // Establecer el color de texto

  // Obtén el ancho y alto del documento
    const docWidth = doc.internal.pageSize.getWidth();
    // const docHeight = doc.internal.pageSize.getHeight();

  // Definir el texto y el estilo
    const texto = 'Wirebit | Detalle de pagos';
    const estilo = { align: 'center' };

  // Calcular la posición del texto
  const textoX = docWidth / 2;
  const textoY = doc.internal.pageSize.getHeight() - doc.internal.getFontSize() - 10; // Margen de 10 unidades desde el borde inferior del documento
  
  // Agregar el texto al documento
    doc.text(texto, textoX, textoY, estilo);
  doc.save(`${service}_${date}.pdf`);
  

}